import { render, staticRenderFns } from "./GBrandBooth.vue?vue&type=template&id=58cf9169&scoped=true&"
import script from "./GBrandBooth.vue?vue&type=script&lang=ts&"
export * from "./GBrandBooth.vue?vue&type=script&lang=ts&"
import style0 from "./GBrandBooth.vue?vue&type=style&index=0&id=58cf9169&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cf9169",
  null
  
)

export default component.exports